module.exports = __webpack_public_path__ + "img/logo_footer.566bd4d6.png";